import _ from 'lodash'
import Backbone from 'backbone'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import DisplayHeader from 'scoreboard/components/display-header'
import i18n from 'scoreboard/components/i18n'
import config from 'scoreboard/components/config'
import permissions from 'scoreboard/components/permissions'
import template from './admin-diagnostics.hbs'
import sectionTemplate from './diagnostic-list.hbs'
import diagnosticTemplate from './diagnostic-item.hbs'

//Enumeration of status values returned by the API
var SUCCESS = 'success',
	ERROR = 'error',
	WARNING = 'warning'

var AdminDiagnostics = Backbone.View.extend({

	className: 'admin table-hack display-layout diagnostics',


	//Backbone Functions

	/**
	 * @param options.diagnostics is an array of diagnostic objects
	 */
	initialize: function(options) {
		this.options = options || {}

		var diagnosticsInfo = {
			'admin.diagnostics.url':  {
				resolutionTargets: '/admin/server',
				icon: 'server'
			},
			'admin.diagnostics.mailserver': {
				resolutionTargets: '/admin/server',
				icon: 'email'
			},
			'admin.diagnostics.exportserver': {
				resolutionTargets: '/admin/server',
				icon: 'server'
			},
			'admin.diagnostics.orb': {
				icon: 'server'
			},
			'admin.diagnostics.registration': {
				resolutionTargets: '/admin/licenses',
				icon: 'registration'
			},
			'common.database': {
				resolutionTargets: '/admin/scoreboard-databases',
				icon: 'database'
			},
			'admin.diagnostics.license': {
				resolutionTargets: '/admin/licenses',
				icon: 'diagnostic-license' // Fixes #59794
			}
		}
		this.categories = this._partitionDiagnostics(diagnosticsInfo)
		this._setHeaderStatus(this.diagnostics, this.categories)
		this.version = i18n.get('login.version', config.version)
	},

	render: function() {
		this.removeChildren()
		this.$el.empty().append(new DisplayHeader({
			heading: i18n.get('diagnostic'),
			mobileGearHidden: true
		}).render().el, template(this))

		_.forEach([ERROR, WARNING, SUCCESS], function(section){
			var category = this.categories[section]
			//Sections should only be displayed if they have diagnostics in them
			if( category.length > 0 ){
				var sectionClass = '.diagnostics-' + section
				var sectionHeader = 'admin.diagnostics.section.' + section
				this._addSection(sectionClass, category, sectionHeader)
			}
		}.bind(this))

		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })

		return this
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		this.removeChildren()
	},

	removeChildren: function() {
		_.invokeMap([this.covertButtonTooltips], 'remove')
	},

	// Initialization

	/**
	 * groups diagnostic results by their status (error, warn, success)
	 * @param resolutionTargets
	 * @private
	 */
	_partitionDiagnostics: function (dianosticsInfo) {

		var diagnostics = _.map(this.options.diagnostics, function (d) {
			return {
				id: d.id,
				status: d.status,
				successful: d.status === SUCCESS,
				messages: d.messages,
				url: dianosticsInfo[d.id].resolutionTargets,
				icon: dianosticsInfo[d.id].icon
			}
		})
		this.diagnostics = diagnostics

		return _.reduce(diagnostics, function (acc, d) {
			acc[d.status].push(d)
			return acc
		}, { error: [], warning: [], success: []})
	},

	/**
	 * Sets the value that should be displayed at the top of the page
	 * @diagnostics all of the diagnostics
	 * @categories diagnostics grouped by type
	 * @private
	 */
	_setHeaderStatus: function (diagnostics, categories) {
		var message = i18n.get('admin.diagnostics.good')
		if (categories.error.length > 0) {
			message = i18n.get('admin.diagnostics.errors')
		} else if (categories.warning.length > 0) {
			message = i18n.get('admin.diagnostics.warnings')
		}

		this.status = {
			message: message,
			success: diagnostics.length === categories.success.length
		}
	},

	/**
	 * Appends the sections (errors, no issues) to the primary diagnostics template
	 * @param className {string} example: '.diagnostics-failed'
	 * @param diagnostics {Array} zero or more diagnostics
	 * @param titleKey {string} For title displayed in the section header
	 */
	_addSection: function(className, diagnostics, titleKey){
		var data = {
			diagnostics: diagnostics,
			heading: titleKey
		}

		this.$(className).append(sectionTemplate(data))

		// Insert each diagnostic
		var html = ''
		_.each(diagnostics, function (d) {
			html += diagnosticTemplate(d)
		})
		this.$(className + ' .list').html(html)
	}

})

export default AdminDiagnostics

AdminDiagnostics.__filename__ = 'admin/diagnostics/admin-diagnostics.js'
